import React from 'react';
import { useSelector } from 'react-redux';
import TagModel from '@mm/state/model/TagModel';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { AccordionItem } from '@mm/components';
import { Tag } from '../../../../contacts/components/Tag/Tag';
import './OTNTags.pcss';
import { BellFilled } from '@ant-design/icons';

type Props = {
  contactId: number;
  otnTags: TagModel[];
};

export const OTNTags = (props: Props) => {
  const { otnTags, contactId } = props;
  const fbPageId = useSelector(activeFacebookPageIdSelector);

  if (!otnTags.length) {
    return null;
  }

  return (
    <div className="contact-otn-tags">
      <AccordionItem
        icon={<BellFilled className="contact-details__nested-header-icon" />}
        title="OTN Tags"
        count={otnTags.length}
        closeOnOutsideClick={false}
        className="contact-details__nested-accordion-item"
        headingClassName="contact-details__accordion-item-heading"
        withBorder={false}
      >
        {!!otnTags.length && (
          <div className="contact-otn-tags__list">
            {otnTags.map(tag => (
              <Tag
                key={tag.name}
                item={tag}
                contactId={contactId}
                fbPageId={fbPageId}
                removable={false}
                otnTags
              />
            ))}
          </div>
        )}
      </AccordionItem>
    </div>
  );
};
